import * as React from 'react';
import { SVGProps } from 'react';

const IconDownloadSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 15v-2H1v2h14zm-3.465-9.94L8.994 7.594 9.006 1h-2l-.012 6.594-2.53-2.534L3.05 6.474l4.944 4.949 4.955-4.95-1.414-1.413z" />
  </svg>
);
export default IconDownloadSizeS;
